export class CallLog {
  id: number;
  lineNumber: string;
  tel: string;
}
 
